import cn from 'classnames';
import header from './Header.module.scss';

const Burger = ({ onClick }) => {
  return (
    <div className={header.header__burger_box}>
      <div
        id="nav-icon3"
        className={cn(header.header__btn_menu_mobile, 'btn-menu-mobile')}
        onClick={onClick}
      >
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default Burger;
